import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

export function createEcho() {
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("access_token");

  return new Echo({
    broadcaster: "pusher",
    key: "03ba04c9d7a23ec7e041", // same as PUSHER_APP_KEY in backend .env
    cluster: "eu", // same as PUSHER_APP_CLUSTER
    forceTLS: true,
    authEndpoint: "https://marketingvps.lyon-jo.com/api/broadcasting/auth",
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });
}
